<template>
  <OptionsList
    class="py-4"
    :active="active"
    :select="select"
    :data-label="singularize(filterType)"
    :options="options"
  />
</template>

<script setup>
import OptionsList from "@/pages/ListingsPage/filters/mobile/OptionsList.vue"
</script>

<script>
import { mapActions, mapState } from "vuex"
import pluralize from "pluralize"

export default {
  name: "MultiSelectFilter",
  props: ["filterType", "options"],
  methods: {
    active(filter) {
      return this.selected.includes(filter)
    },
    select(filter) {
      !this.selected.includes(filter) ? this.add(filter) : this.remove(filter)
    },
    add(filter) {
      this.mergeFilter({ [this.filterType]: [...this.selected, filter] })
    },
    remove(filter) {
      this.mergeFilter({ [this.filterType]: this.selected.filter((val) => val != filter) })
    },
    singularize(word) {
      return pluralize.singular(word)
    },
    ...mapActions("filter", ["mergeFilter"]),
  },
  computed: {
    selected() {
      return this.filters[this.filterType]
    },
    ...mapState("filter", ["filters"]),
  },
}
</script>
